import { SxProps } from '@mui/material';
import { Theme } from '@mui/system';
import { useTranslation } from 'react-i18next';
import { CartBar } from './cartBar';

export interface StickyCartBarProps {
  barText?: string;
  open?: () => void;
  isPurchase?: boolean;
  isDisabled?: boolean;
  sx?: SxProps<Theme>;
  isSmallFont?: boolean;
  price?: number;
  hideBadge?: boolean;
}

export function StickyCartBar(props: StickyCartBarProps) {
  const { t } = useTranslation();
  const { isPurchase = false } = props;
  const barText = props.barText ?? (isPurchase ? t('payment:pay') : t('payment:cart'));

  return (
    <CartBar
      position="sticky"
      barText={barText}
      isDisabled={props.isDisabled}
      open={props.open}
      isSmallFont={props.isSmallFont}
      isPurchase={isPurchase}
      price={props.price}
      hideBadge={props.hideBadge}
      sx={[
        {
          width: 'auto',
          borderRadius: '10px',
        },
        ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
      ]}
    />
  );
}
